const ROLE_FORBIDDEN_ROUTES = {
    warehouse: ["/usuarios", "/integraciones", "/contabilidad"],
};

const ROLE_DEFAULT_HOME = {
    warehouse: "/",
};

export function defaultHomeForRole(role) {
    if (role === "client") return "/portal";
    if (role === "cleaner" || role === "technician") return "/operario";
    if (ROLE_DEFAULT_HOME[role]) return ROLE_DEFAULT_HOME[role];
    return "/";
}

export function isRouteAllowedForRole(role, path) {
    const forbidden = ROLE_FORBIDDEN_ROUTES[role] || [];
    return !forbidden.some((route) => path === route || path.startsWith(route + "/"));
}
